<template>
  <div>
    <ViewLoadingMessage :loading="!photoService.events"/>
    
    <CCardBody class="p-0" v-if="photoService.events">
      <CDataTable
          :loading="eventsLoading"
          :striped="true"
          :sorter='{ external: true, resetable: false }'
          :sorter-value="sorterValueEvents"
          :items="photoService.events.results"
          :fields="getPhotoServiceEventsFields"
          @update:sorter-value="sortEvents"
          class="custom-table custom-table--clean custom-table--nested mb-4">
        
        <template #no-items-view>
          <div class="text-center">
            <h6 v-translate>No data</h6>
          </div>
        </template>
        
        <template #sorting-icon="{ state, classes }">
          <div :class="classes">
            <CIcon name="cipCaretUp" size="lg" v-if="state === 'asc' || state === 0"></CIcon>
            <CIcon name="cipCaretUp" size="lg" v-else></CIcon>
          </div>
        </template>

        <template #pica_service_name="{ item }">
          <td>
            <CLink tabindex="-1" :to="{
              name: 'stats',
              params: { picaServiceId: item.pica_service_id }}">
              {{ item.pica_service_name }}
            </CLink>
          </td>
        </template>
        
        <template #checkin_count="{ item }">
          <td>{{ item.checkin_count | number }}</td>
        </template>
        
        <template #order_count="{ item }">
          <td>{{ item.order_count | number }}</td>
        </template>
        
        <template #start_at="{ item }">
          <td>{{ item.start_at | formatDate('L') }}</td>
        </template>
        
        <template #turnover="{ item }">
          <td class="text-right">{{ item.turnover | currency(currencyCodes.EUR) }}</td>
        </template>
        
        <template #presale="{ item }">
          <td class="text-right">{{ item.presale | currency(currencyCodes.EUR) }}</td>
        </template>
        
        <template #amount="{ item }">
          <td class="text-right">
            <div class="totalEvent">{{ item.amount | currency(item.currency) }}</div>
            <div class="totalEventEur" v-if="item.currency !== currencyCodes.EUR">
              {{ item.amount_eur | currency(currencyCodes.EUR) }}
            </div>
          </td>
        </template>
      </CDataTable>
    </CCardBody>

    <CCardFooter v-if="photoService.events && photoService.events.pagination.num_pages > 1">
      <CPagination
          @update:activePage="changePagePhotoServiceEventsTotals"
          :active-page.sync="photoService.events.pagination.page_number"
          :pages="photoService.events.pagination.num_pages"/>
    </CCardFooter>
  </div>
</template>

<script>
import ViewLoadingMessage from "@/components/ViewLoadingMessage.vue"
import { mapActions } from "vuex"
import { currencyCodes } from "@/constants"
import { 
  INDUSTRIES_ER
} from "@/views_pica/stats/constants"
import { photoServiceEventsFields, photoServiceEventsFieldsER } from "../constants"

export default {
  name: "PhotoServiceEventsTable",
  
  components: {
    ViewLoadingMessage
  },
  
  props: {
    photoService: {
      type: Object,
      required: true
    },
    industry: {
      type: String,
      required: true
    }
  },
  
  data() {
    return {
      sorterValueEvents: null,
      eventsLoading: false
    }
  },
  
  computed: {
    currencyCodes() {
      return currencyCodes
    },
    
    INDUSTRIES_ER() {
      return INDUSTRIES_ER
    },
    
    photoServiceEventsFields() {
      let fields = Object.values(photoServiceEventsFields)
      // Filter fields based on permissions if needed
      return fields
    },
    
    photoServiceEventsFieldsER() {
      return Object.values(photoServiceEventsFieldsER)
    },
    
    isIndustryER() {
      return this.INDUSTRIES_ER.includes(this.industry)
    },
    
    getPhotoServiceEventsFields() {
      return this.isIndustryER ? this.photoServiceEventsFieldsER : this.photoServiceEventsFields
    }
  },
  
  // Events are loaded by parent component when photo service is expanded
  
  methods: {
    ...mapActions('salesReport', ['fetchPhotoServiceEventsTotals']),
    
    
    async loadEvents(params = {}) {
      try {
        // Default ordering if not passed in params
        if (!params.order_by) {
          this.sorterValueEvents = {
            "asc": false,
            "column": this.isIndustryER ? 'amount' : 'turnover'
          }
          params.order_by = this.isIndustryER ? '-amount' : '-turnover'
        }

        const response = await this.fetchPhotoServiceEventsTotals({
          photoServiceId: this.photoService.id,
          industry: this.industry,
          params
        })
        
        this.$set(this.photoService, 'events', response)
        this.$set(this.photoService, '_eventsLoaded', true)
        this.$emit('events-loaded', { photoService: this.photoService, events: response })
      } catch (error) {
        console.error('Error loading photo service events:', error)
      }
    },
    
    async sortEvents(event) {
      this.eventsLoading = true
      const params = {
        'order_by': `${event.asc ? '' : '-'}${event.column}`
      }
      await this.loadEvents(params)
      this.eventsLoading = false
    },
    
    changePagePhotoServiceEventsTotals(page) {
      this.loadEvents({page: page})
    }
  }
}
</script>